export const CAMPAIGN = {
  DEFAULT: 'nations-champs',
} as const;

export const FORM_TYPES = {
  ENTRY: 'entry',
} as const;

export const PAGES = {
  ROOT: '/',
  TEAM_SELECTION: '/teamselection-nh',
  PREDICTOR: '/predictor',
  ENTRY: '/entry',
  SURVEY: '/survey',
  CONFIRM: '/confirm',
  SUBMISSION: '/submission',
  TERMS: '/terms',
} as const;

export const ENDPOINTS = {
  // Local API
  GEOIP: '/geoip',
  ENTRY: '/entry',

  // Payload CMS
  PAYLOAD_PAGES: '/api/pages',
  PAYLOAD_HEADER: '/api/header',
  PAYLOAD_FOOTER: '/api/footer',
  PAYLOAD_META: '/api/tenants',
  PAYLOAD_FORM: '/api/common-form',
} as const;

export const STORAGE = {
  DEFAULT: {
    ENTRY_EMAIL: 'nations-champs-default-email',
  },
};

export const CONTENT = {
  META: 'csk',
  HEADER: 'csk-header',
  FOOTER: 'csk-footer',
} as const;

export const DEFAULT_LOCALE = 'en';

export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? '';

export function withBasePath(path: string | undefined | null): string {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  const normalised = path.startsWith('/') ? path : `/${path}`;
  return `${BASE_PATH}${normalised}`;
}

export const SHORT_LOCALES = ['en', 'fr', 'es'] as const;

export const LOCALES = [
  {
    code: 'en',
    name: 'English',
  },
  {
    code: 'fr',
    name: 'Français',
  },
  {
    code: 'es',
    name: 'Español',
  },
] as const;

export const ORIGIN = {
  local: {
    en: 'http://localhost:3001/en',
    fr: 'http://localhost:3001/fr',
    es: 'http://localhost:3001/es',
  },
  test: {
    en: 'http://localhost:3001/en',
    fr: 'http://localhost:3001/fr',
    es: 'http://localhost:3001/es',
  },
  development: {
    en: 'https://nations-champs-eks.dev.csm.reviews/en',
    fr: 'https://nations-champs-eks.dev.csm.reviews/fr',
    es: 'https://nations-champs-eks.dev.csm.reviews/es',
  },
  staging: {
    en: 'https://nations-champs-eks.stg.csm.reviews/en',
    fr: 'https://nations-champs-eks.stg.csm.reviews/fr',
    es: 'https://nations-champs-eks.stg.csm.reviews/es',
  },
  production: {
    en: 'https://predictor.nationschampionshiprugby.com/en',
    fr: 'https://predictor.nationschampionshiprugby.com/fr',
    es: 'https://predictor.nationschampionshiprugby.com/es',
  },
} as const;

export const getPayloadUrl = (environment: Environment) =>
  ({
    local: 'http://127.0.0.1:3000',
    test: 'https://payload-cms-mongo-eks.dev.csm.reviews',
    development: 'https://payload-cms-mongo-eks.dev.csm.reviews',
    staging: 'https://payload-cms-mongo-eks.stg.csm.reviews',
    production: 'https://payload-m.partnership-hub.co.uk',
  })[environment];

export const getPayloadEnvironment = (url: string | undefined): Environment =>
  (
    ({
      local: 'local',
      dev: 'development',
      stg: 'staging',
      prod: 'production',
    }) as Record<string, Environment>
  )[url?.match(/.+\.(dev|stg|prod)\..+/)?.[1] ?? 'local'] ?? 'local';

export const PAYLOAD_BASE_URL = (
  {
    local: 'http://127.0.0.1:3000',
    test: 'https://payload-cms-mongo-eks.dev.csm.reviews',
    development: 'https://payload-cms-mongo-eks.dev.csm.reviews',
    staging: 'https://payload-cms-mongo-eks.stg.csm.reviews',
    production: 'https://payload-m.partnership-hub.co.uk',
  } as const
)[process.env.ENVIRONMENT];

export const PAYLOAD_ENVIRONMENT = PAYLOAD_BASE_URL?.match(/.+\.(dev|stg|prod)\..+/)?.[1];
export const SALESFORCE = {
  REST_DOMAIN: process.env.SALESFORCE_REST_ENDPOINT,
  AUTH_DOMAIN: process.env.SALESFORCE_AUTH_ENDPOINT,
  CLIENT_ID: process.env.SALESFORCE_CLIENT_ID,
  ACCOUNT_ID: process.env.SALESFORCE_ACCOUNT_ID,
  CLIENT_SECRET: process.env.SALESFORCE_CLIENT_SECRET,
  MAX_EXPIRATION_DIFF_MS: 10000, // ms - 10s
  UPSERT_URL: `${process.env.SALESFORCE_REST_ENDPOINT}/hub/v1/dataevents/key:<key>/rowset`,
  DE: {
    MASTER: process.env.SALESFORCE_MASTER_DE_KEY,
    CAMPAIGN: process.env.SALESFORCE_CAMPAIGN_DE_KEY,
  },
} as const;

export const REQUIRED_QUERY_PARAMS = [
  // 'utm_source',
  // 'utm_medium',
  // 'utm_campaign',
  // 'utm_term',
  // 'utm_content',
] as const;

export const BREAKPOINTS = {
  SM: 431,
  MD: 541,
  LG: 1024,
  XL: 1440,
  XXL: 1920,
  XXXL: 2560,
};

export const SSG_REVALIDATE_RATE_SEC = 10;
export const GEO_FALLBACK_CLIENT_IP = '0.0.0.0';
export const SENTRY_ENVIRONMENT = process.env.ENVIRONMENT ?? process.env.NEXT_PUBLIC_ENVIRONMENT;
// prettier-ignore
export const SENTRY_DSN = 'https://57fd13775f909d99c8251cb8bc5c3cf0@o4506433853849600.ingest.us.sentry.io/4506472334032896';
export const SENTRY_TRACE_SAMPLE_RATE = 0.1;
export const SENTRY_REPLAY_SAMPLE_RATE = 0.1;
export const SENTRY_ERROR_SAMPLE_RATE = 1.0;
export const RESIZE_POLL_RATE_MS = 200;
export const FALLBACK_ALT = 'No descriptive information provided about the image.';
// prettier-ignore
export const FALLBACK_IMAGE = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=';
